export default __webpack_public_path__ + "static/media/confirmInvoiceActive.faf79810.svg";